module.exports = __webpack_public_path__ + "img/egypt.c6d68c9c.svg";